import { Button } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * @description Renders a primary button component.
 *
 * @author Maria Eduarda Franke
 * @param {React.ElementType} props.Icon - The icon component to be displayed at the start of the button.
 * @param {string} props.label - The label text of the button.
 * @param {boolean} props.loading - Indicates whether the button is in a loading state.
 * @param {function} props.onClick - The click event handler for the button.
 * @returns {React.Element} The rendered primary button component.
 */
const PrimaryButton = ({ Icon, label, loading, onClick, ...props }) => {
    return (
        <Button
            startIcon={Icon && <Icon />}
            variant='contained'
            color='primary'
            onClick={onClick}
            disabled={loading}
            sx={{
                fontWeight: "bold"
            }}
            {...props}
        >
            {label}
        </Button>
    )
}

PrimaryButton.propTypes = {
    Icon: PropTypes.object,
    label: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    onClick: PropTypes.func
}

export default PrimaryButton
